export const ACTIVITY_LEVELS = {
    1: 1.2,
    2: 1.4,
    3: 1.6,
    4: 1.8,
    5: 2
};